import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Separator from "./separador";
import Servicio from "../img/servicio1.svg";
import Servicio2 from "../img/servicio2.svg";
import Servicio3 from "../img/servicio3.svg";
import Servicio4 from "../img/servicio4.svg";
import Clientes2 from "../img/clientes2.png";
import Clientes3 from "../img/clientes3.png";

import "./main.css";

function mainservices() {
  return (
    <Container>
      <Separator />
      <div className="Center">
        <br />
        <h1 id="Services">Our services</h1>
        <br />
        <p>
          "Bringing your vision to reality with an end-to-end approach: Initial
          planning, implementation, and final support".
        </p>
        <br />
      </div>
      <br />
      <Row xs={1} md={4} className="g-4">
        {Array.from({ length: 1 }).map((_, idx) => (
          <Col key={idx}>
            <Card className="cardS">
              <Card.Img variant="top" id="servicio1" src={Servicio} />
              <Card.Body>
               
                <Card.Title className="Center">Preliminary planning</Card.Title>
                <Card.Text className="Center">
                  We collaborate with you to develop the most efficient design,
                  ensuring your project is completed within your timeline and
                  budget.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}

        {Array.from({ length: 1 }).map((_, idx) => (
          <Col key={idx}>
            <Card className="cardS">
              <Card.Img variant="top" id="servicio1" src={Servicio2} />
              <Card.Body>
                <Card.Title className="Center">
                  Drafting and Visualizations
                </Card.Title>
                <Card.Text className="Center">
                  We create engineered shop drawings and calculations for
                  permitting, along with vibrant 3-D renderings available in
                  color or black and white.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}

        {Array.from({ length: 1 }).map((_, idx) => (
          <Col key={idx}>
            <Card className="cardS">
              <Card.Img variant="top" id="servicio1" src={Servicio3} />
              <Card.Body>
                <Card.Title className="Center">Manufacture</Card.Title>
                <Card.Text className="Center">
                  We manufacture locally at our own facility in Miami, Florida.
                  Don't hesitate to reach out and schedule a visit!
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}

        {Array.from({ length: 1 }).map((_, idx) => (
          <Col key={idx}>
            <Card className="cardS">
              <Card.Img variant="top" id="servicio1" src={Servicio4} />
              <Card.Body>
                <Card.Title className="Center">Installation</Card.Title>
                <Card.Text className="Center">
                  Count on our dedicated installation team, equipped with
                  expertise and precision, to meticulously execute every aspect
                  of your project on-site.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Separator />

      {/* Aquí comienzan los clientes */}
      <div className="Center">
        <br />
        <h1 id="Clients">Our clients who we work</h1>
        <br />
        <p>
          Distinguished Clients Who Have Entrusted Us with Collaboration on
          their exceptional projects
        </p>
        <br />
      </div>
      <br />

      <Row xs={1} md={3} className="g-5">
        {Array.from({ length: 1 }).map((_, idx) => (
          <Col key={idx}>
            <Card.Link href="https://www.t-and-g.com/">
              <Card className="cardC">
                <Card.Img
                  variant="top"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-9w2cBo2KUkyw65WY08_sH5F9cjIZuHhWlw&s"
                />
                <Card.Body></Card.Body>
              </Card>
            </Card.Link>
          </Col>
        ))}

        {Array.from({ length: 1 }).map((_, idx) => (
          <Col key={idx}>
            <Card className="cardC">
              <Card.Img variant="top" id="Clientes" src={Clientes2} />
              <Card.Body></Card.Body>
            </Card>
          </Col>
        ))}

        {Array.from({ length: 1 }).map((_, idx) => (
          <Col key={idx}>
            <Card.Link href="https://www.aquantisgroup.com/">
              <Card className="cardC">
                <Card.Img
                  variant="top"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ6JP-pJCLUWJOWh9QxA-FgvADQeIkt0gBVVQ&s"
                />
                <Card.Body></Card.Body>
              </Card>
            </Card.Link>
          </Col>
        ))}

        {Array.from({ length: 1 }).map((_, idx) => (
          <Col key={idx}>
            <Card.Link href="https://www.tri-techconstruction.net/">
              <Card className="cardC">
                <Card.Img
                  variant="top"
                  src="https://images.squarespace-cdn.com/content/v1/59358a2815d5dba11b3c643c/1496765954026-MM45G2X2UJHG5HFRNSZR/tri+tech.png"
                />
                <Card.Body></Card.Body>
              </Card>
            </Card.Link>
          </Col>
        ))}

        {Array.from({ length: 1 }).map((_, idx) => (
          <Col key={idx}>
            <Card.Link href="https://cbtdevelopments.com.au/">
              <Card className="cardC">
                <Card.Img
                  className="fax"
                  variant="top"
                  id="Clientes2"
                  src={Clientes3}
                />
                <Card.Body></Card.Body>
              </Card>
            </Card.Link>
          </Col>
        ))}

        {Array.from({ length: 1 }).map((_, idx) => (
          <Col key={idx}>
            <Card.Link href="https://zconstructors.com/">
              <Card className="cardC">
                <Card.Img
                  className="fix"
                  variant="top"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjHLWqvqeTfdAsY7ydUQ0bBIA-c3uOYHv4QA&s"
                />
                <Card.Body></Card.Body>
              </Card>
            </Card.Link>
          </Col>
        ))}
      </Row>

      <Separator />
    </Container>
  );
}

export default mainservices;
